import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FaPlus } from 'react-icons/fa';
import { deleteBookingHotel, removeHotelDocument } from 'redux/booking/travel/travelBookingSlice';
import { Button, Confirmation } from 'components/common';
import HotelItem from './HotelItem';
import HotelForm from './HotelForm';

const HotelList = ({ booking }) => {
  const [showModalHotel, setShowModalHotel] = useState(false);
  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [hotel, setHotel] = useState(null);
  const { hotels } = booking;

  const bookingId = booking.id;
  const dispatch = useDispatch();

  const handleEditHotelBooking = (h) => { setHotel(h); setShowModalHotel(true); };
  const handleCreateHotelBooking = () => { setHotel(null); setShowModalHotel(true); };
  const handleDeleteHotelBooking = (h) => { setHotel(h); setShowConfirmationDelete(true); };
  const handleRemoveAttachment = (hotelId, documentId) => dispatch(removeHotelDocument({ bookingId, hotelId, documentId }));

  const handleOkConfirm = () => {
    dispatch(deleteBookingHotel({ bookingId, hotelId: hotel.id }));
    setShowConfirmationDelete(false);
  };

  return (
    <>
      <div className="tw-flex tw-justify-end tw-mb-3">
        <Button size="sm" variant="secondary" leftIcon={FaPlus} onClick={handleCreateHotelBooking}>New Hotel Booking</Button>
      </div>

      {(hotels || []).map((h) => (
        <HotelItem
          key={h.id}
          booking={booking}
          hotel={h}
          editHotelBooking={() => handleEditHotelBooking(h)}
          deleteHotelBooking={() => handleDeleteHotelBooking(h)}
          handleRemoveAttachment={handleRemoveAttachment}
        />
      ))}

      <HotelForm showModal={showModalHotel} setshowModal={setShowModalHotel} booking={booking} hotel={hotel} />

      <Confirmation
        show={showConfirmationDelete}
        type="danger"
        title="Delete hotel"
        message="Are you sure to delete?"
        confirmText="Delete"
        onConfirm={handleOkConfirm}
        onCancel={() => setShowConfirmationDelete(false)}
      />
    </>
  );
};

HotelList.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default HotelList;
